import React from 'react';
import { SelectInput } from '@thinknet-gmbh/platform-common-ui';

import { SKIP_LABEL } from '../../document-importer-list.constants';
import { IDocumentImporterPreviewRowTableProps } from '../../document-importer-list.interfaces';
import { SelectContainer } from './document-importer-preview-table.styles';

const EmployeeRowSelect = ({
  record,
  handleEmployeeChange,
  t,
  employeesOptions,
  isPreview,
}: IDocumentImporterPreviewRowTableProps) => {
  return (
    <SelectContainer>
      <SelectInput
        disabled={isPreview}
        value={record?.memberId || SKIP_LABEL.value}
        className={'file-emp-select'}
        placeholder={t('documentImporter:labels.selectDocumentType')}
        {...(handleEmployeeChange && { onSelect: handleEmployeeChange(record) })}
      >
        {employeesOptions.map(({ value, label }) => (
          <SelectInput.Option key={value} value={value}>
            {label}
          </SelectInput.Option>
        ))}
      </SelectInput>
    </SelectContainer>
  );
};

export default EmployeeRowSelect;
